<!-- 嵌入式-远程命令管理（包括嵌入式和工控，通过业务组类型BusinessGroup区分 0.嵌入式 1.工控） -->
<template>
  <div>
    <div class="top">
      <div class="left">
        <el-button type="primary" @click="onCreateCommandClick">
          <i class="fas fa-plus"></i> 新增命令
        </el-button>
      </div>
      <div class="right">
        <el-input
          v-model.trim="commandformer['Name:like']"
          placeholder="命令名称"
          @keydown.enter.native="onCommandSubmitQuery"
          style="width: 200px"
        >
        </el-input
        >&nbsp;
        <el-button type="primary" @click="onCommandSubmitQuery">
          <i class="fas fa-search"></i>
        </el-button>
      </div>
    </div>

    <div id="app">
      <el-table :data="commandItemList" v-loading="commandLoading">
        <el-table-column
          type="index"
          :index="commandPager.size * (commandPager.page - 1) + 1"
          :width="
            Math.max(
              40,
              (commandPager.size * commandPager.page).toString().length * 12
            )
          "
        />
        <el-table-column
          label="命令名称"
          prop="Name"
          width="150"
        ></el-table-column>
        <el-table-column label="命令编号" prop="Code" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.Code">
              <el-tag>
                {{ scope.row.Code }}
              </el-tag>
            </div>
            <div v-else>——</div>
          </template>
        </el-table-column>
        <el-table-column
          label="命令等级"
          prop="CommandGrade.Name"
          width="80"
        ></el-table-column>
        <el-table-column prop="Title" label="命令主题" width="150" />
        <el-table-column label="命令内容">
          <template slot-scope="scope">
            <div>
              {{ scope.row.Payload }}
            </div>
          </template>
        </el-table-column>
        <el-table-column label="是否公开" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.IsPublic" type="warning"> 是 </el-tag>
            <el-tag v-else type="success"> 否 </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="是否二次确认" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.IsSecondConfirmation" type="warning"> 是 </el-tag>
            <el-tag v-else type="success"> 否 </el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="Desc"
          label="提示说明"
          width="150"
          show-overflow-tooltip
          ><template scope="scope">
            <span>{{ scope.row.Desc }}</span>
          </template>
        </el-table-column>
        <el-table-column width="140" label="操作">
          <template slot-scope="scope">
            <el-button
              type="primary"
              @click.stop="onEditCommandClick(scope.row)"
              title="编辑"
            >
              <i class="fas fa-pencil-alt"></i>
            </el-button>
            <el-button
              type="danger"
              @click.stop="onDeleteCommandClick(scope.row)"
              title="删除"
            >
              <i class="fas fa-trash-alt"></i>
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="clearfix mar-top-10">
      <el-pagination
        class="pull-right"
        @current-change="onCommandChangePage"
        layout="total, prev, pager, next"
        :total="commandPager.total"
        :current-page="commandPager.page"
        :page-size="commandPager.size"
      >
      </el-pagination>
    </div>

    <command-form
      v-model="commandItem"
      :visible.sync="commandFormVisible"
      @form:saved="getCommandList"
    />
  </div>
</template>


<script>
import CommandForm from "./commandForm.vue";

export default {
  components: {
    CommandForm,
  },
  props: ["group"],
  data() {
    return {
      commandItemList: [],
      commandLoading: false,
      commandPager: {
        total: 0,
        page: 1,
        size: 15,
      },
      commandformer: {
        "Name:like": "",
        BusinessGroup: this.group, //业务组类型 0.嵌入式 1.工控，必传0
      },
      commandFormVisible: false,
      commandItem: this.getEmptyCommandItem(),
    };
  },
  mounted() {
    this.getCommandList();
  },
  methods: {
    //获取命令列表
    getCommandList() {
      this.commandLoading = true;
      this.$axios
        .get("command", {
          params: {
            where: this.commandformer,
            with: ["CommandGrade"],
            ...this.commandPager,
            order: ["name"],
          },
        })
        .then((response) => {
          this.commandItemList = response.data.data;
          this.commandPager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.commandLoading = false;
        });
    },
    //新增命令
    onCreateCommandClick() {
      this.commandItem = this.getEmptyCommandItem();

      if (this.group === "0") {
        this.commandItem.Title = "$cd";
      }
      this.commandFormVisible = true;
    },
    //编辑命令
    onEditCommandClick(row) {
      this.commandItem = this.getEmptyCommandItem();
      this.commandItem = row;
      this.commandFormVisible = true;
    },
    getEmptyCommandItem() {
      return {
        Name: "", //命令名称
        Title: "", //命令主题
        Code: "", //命令编号
        Payload: "", //命令内容
        IsPublic: false, //是否公开0:否  1:是
        CommandGradeID: "", //命令等级id（常量维护）
        ExtraParams: [], //额外参数
        ExtraIndex: "", //额外索引字段
        Desc: "", //提示说明
        BusinessGroup: this.group, //业务组类型 0.嵌入式 1.工控
      };
    },
    //删除命令
    onDeleteCommandClick(row) {
      this.$confirm("确定要删除此命令吗？", "提示")
        .then(() => this.$axios.delete(`command/${row.ID}`))
        .then(() => {
          this.getCommandList();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    onCommandSubmitQuery() {
      this.commandPager.page = 1;
      this.getCommandList();
    },
    onCommandChangePage(page) {
      this.acceptPager.page = page;
      this.getCommandList();
    },
  },
};
</script>

<style scoped lang="scss" scoped>
.top {
  text-align: right;
  background-color: #f5f7fa;
  height: 30px;
  padding: 30px 30px 10px 30px;
  margin: -20px -20px 10px -20px;
}
.left {
  float: left;
  text-align: left;
  width: 80px;
}
.right {
  float: right;
  text-align: right;
  width: 80%;
}
#app {
  width: 100%;
  height: 100%;
  .el-table {
    // 看这里！！！！！！！！！！！！！！！！！！！！！！！！！！！！
    // 深度选择器，去除默认的padding
    /deep/ th {
      padding: 0 0 10 0;
      font-size: larger;
    }
  }
}
</style>